import { ShowSnackBar } from "event-definitions"

export function warningSnackbar(message, options = {}) {
    ShowSnackBar.raiseLater(message, { variant: "warning", ...options })
}
